// Configuration for logging
export const environment = {
  production: true,
  logLevel: 'error'
};